import { Question, FeedbackFormState } from './interfaces';
import { HAPPINESS_LABELS, RATE_LABELS, DEFAULT_RATE_LABELS } from './constants';

export const isStepValid = (question: Question, answer: any): boolean => {
  switch (question.type) {
    case 'HAPPINESS':
    case 'RATE':
      return answer !== undefined && answer !== null;
    case 'SELECT':
      if (question.multiselect) {
        return Array.isArray(answer) && answer.length > 0;
      }
      return answer !== undefined && answer !== null;
    case 'TEXTAREA':
      return answer !== undefined && answer !== null && answer.trim().length > 0;
    default:
      return false;
  }
};

export const canGoToNextStep = (state: FeedbackFormState): boolean => {
  const currentQuestion = state.data.steps[state.currentStep];
  const currentAnswer = state.answers[currentQuestion.id];
  return isStepValid(currentQuestion, currentAnswer);
};

export const canGoToPreviousStep = (state: FeedbackFormState): boolean => {
  return state.currentStep > 0;
};

export const isLastStep = (state: FeedbackFormState): boolean => {
  return state.currentStep === state.data.steps.length - 1;
};

export const getStepProgress = (state: FeedbackFormState): number => {
  return ((state.currentStep + 1) / state.data.steps.length) * 100;
};

export const getSelectedLabel = (question: Question, answer: any): string => {
  switch (question.type) {
    case 'HAPPINESS': {
      return HAPPINESS_LABELS[answer] || '';
    }
    case 'RATE': {
      const labels = RATE_LABELS[question.id] || DEFAULT_RATE_LABELS;
      return labels[answer] || '';
    }
    case 'SELECT': {
      if (question.multiselect) {
        const selectedOptions = question.options.filter(opt => 
          Array.isArray(answer) && answer.includes(opt.id)
        );
        return selectedOptions.map(opt => opt.text).join(', ');
      }
      const selectedOption = question.options.find(opt => opt.id === answer);
      return selectedOption?.text || '';
    }
    default:
      return '';
  }
};

export const updateAnswer = (
  state: FeedbackFormState,
  questionId: string,
  value: any
): FeedbackFormState => {
  const question = state.data.steps.find(step => step.id === questionId);
  if (!question) return state;

  let newValue = value;
  
  if (question.type === 'SELECT' && question.multiselect) {
    newValue = value;
  }

  return {
    ...state,
    answers: {
      ...state.answers,
      [questionId]: newValue
    }
  };
};

export const getCurrentAnswer = (state: FeedbackFormState): any => {
  const currentQuestion = state.data.steps[state.currentStep];
  return state.answers[currentQuestion.id];
}; 